import { useMutation } from '@apollo/client/react';
import { notify } from '@components/ui/molecules/Toast';
import { ChangePasswordDocument } from '@graphql/types';
import { useCallback } from 'react';

import type { ChangePasswordInput, ChangePasswordResponse } from '../types';

export const useChangePassword = () => {
  const [changePasswordMutation, { loading }] = useMutation(ChangePasswordDocument);

  const doChangePassword = useCallback(
    async (data: ChangePasswordInput): Promise<ChangePasswordResponse> => {
      const response = await changePasswordMutation({
        variables: { input: data },
      });

      const res = response.data?.changePassword;

      if (!res) {
        notify.error({ title: 'Change password failed', description: 'No response from server' });
        throw new Error('Password change failed');
      }

      const hasErrors = res.errors && res.errors.length > 0;

      if (hasErrors) {
        const errorMessage = res.errors?.[0]?.message || 'Faild to change the password. Please try again.';

        notify.error({ title: res.errors?.[0]?.code, description: errorMessage });
      } else {
        notify.success({ title: 'Password change successful' });
      }

      return res;
    },
    [changePasswordMutation]
  );

  return { doChangePassword, changePasswordLoading: loading };
};
